import { util, shapes } from '@clientio/rappid';
import { EndAttributes } from './end.attributes';

export class EndShape extends shapes.standard.Rectangle {
  defaults(): object {
    return util.defaultsDeep(EndAttributes, shapes.standard.Rectangle.prototype.defaults);
  }
}
